import React from "react";
import { useParams } from "react-router-dom";
import ABM_ART_Tamanos from "../../../Componentes/Areas/ABM_ART_Tamanos";
import { PaginaCarga } from "../../../Componentes/Compuestos/Paginas/PaginaCarga";

export const ABM_ART_Tamanos_ModificacionCreacion = () => {

  let Codigo = useParams()

  return (
    <PaginaCarga
      Titulo="TAMAÑOS"
    >
      <ABM_ART_Tamanos Codigo={Codigo} />
    </PaginaCarga>
  );
}
